export class ReceiptModel {
  invoice_no: string = null;
  invoice_to: string = null;
  invoice_date: Date = null;
  label2Name: string = null;
  label2Value: string = null;
  payment_method: string = null;
  paid_to: string = null;
  firstColumnName: string = null;
  firstColumnValue: string = null;
  secondColumnName: string = null;
  secondColumnValue: string | number = null;
  thirdColumnName: string = null;
  thirdColumnValue: string | number = null;
  total_amount: string | number = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}